import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function ImagesBarChart({ chartData }) {
    const imageWidth = 30;
    const imageHeight = 30;

    const images = useMemo(() => {
        return [
            'https://pngimg.com/d/free_PNG90750.png',
            'https://pngimg.com/d/free_PNG90750.png',
            'https://pngimg.com/d/free_PNG90750.png',
            'https://pngimg.com/d/free_PNG90750.png'
        ].map(src => {
            const img = new Image();
            img.src = src;
            return img;
        });
    }, []);

    const imageLabelPlugin = {
        id: 'image-label-plugin',
        afterDatasetsDraw: (chart) => {
            const { ctx, scales } = chart;
            const yAxis = scales.y;

            if (!images.every(img => img.complete)) {
                return;
            }

            chart.getDatasetMeta(0).data.forEach((bar, index) => {
                const img = images[index];
                const x = yAxis.left - imageWidth - 10; // left of the Y axis
                const y = bar.y - imageHeight / 2;

                ctx.drawImage(img, x, y, imageWidth, imageHeight);
            });
        }
    };

    const options = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                left: 50
            }
        },
        scales: {
            x: {
                beginAtZero: true,
                ticks: {
                    display: true
                }
            },
            y: {
                ticks: {
                    display: false // nascondi le label testuali sull'asse y
                }
            }
        },
        plugins: {
            legend: { display: false },
            tooltip: { enabled: true }
        }
    };

    return (
        <Bar
            data={chartData}
            options={options}
            plugins={[imageLabelPlugin]}
            height={400}
        />
    );
}
